























































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class CreateLinkPopup extends Vue {
  @Prop({ required: true }) popupId!: string
  @Prop({ required: true }) brandId!: number

  public form = {
    link_type: '',
    title: '',
    description: '',
    website_link: '',
    ios_link: '',
    android_link: ''
  }
  public busy = false
  public croppers: any[] = new Array(4)
  public linkImages: any[] = new Array(4)
  public imageNames: any[] = ['', '', '', '']

  get appInstallLinkError (): string {
    if (this.form.link_type !== 'app-install') return ''
    const ios = (this.form.ios_link || '').trim()
    const android = (this.form.android_link || '').trim()
    if (!ios && !android) return 'Please enter at least one of iOS or Android link.'
    return ''
  }

  generateImage (index: number) {
    if (!this.croppers[index] || !this.croppers[index].hasImage()) return
    const url = this.croppers[index].generateDataUrl()
    if (url) Vue.set(this.linkImages, index, url)
  }

  saveLink () {
    if (this.form.link_type === 'app-install' && this.appInstallLinkError) {
      this.$notify({ text: this.appInstallLinkError, type: 'error' })
      return
    }
    for (let i = 0; i < 4; i++) this.generateImage(i)
    this.$validator.validateAll('create-link-form').then((result) => {
      if (!result) {
        this.$notify({ text: 'Please fix the errors below.', type: 'error' })
        return
      }
      if (this.busy) return
      const linkType = (this.form.link_type || '').trim()
      const title = (this.form.title || '').trim()
      const images: any[] = []
      this.linkImages.forEach((dataUrl, index) => {
        if (dataUrl && dataUrl.length > 0) {
          images.push({ image: dataUrl, description: (this.imageNames[index] || '').trim() })
        }
      })
      this.busy = true
      const linkPayload = {
        link_type: linkType,
        title,
        description: (this.form.description || '').trim(),
        website_link: linkType === 'watch' || linkType === 'review' ? (this.form.website_link || '').trim() : '',
        ios_link: linkType === 'app-install' ? (this.form.ios_link || '').trim() : '',
        android_link: linkType === 'app-install' ? (this.form.android_link || '').trim() : ''
      }
      this.$http.post(`brands/${this.brandId}/links`, linkPayload).then((response: any) => {
        const linkId = (response.body && (response.body.id || (response.body.data && response.body.data.id))) || null
        if (images.length > 0 && linkId) {
          this.$store.dispatch('uploadLinkImages', {
            brandId: this.brandId,
            linkId,
            images
          }).then(() => {
            this.$notify({ text: 'Link and images saved successfully', type: 'success' })
            this.resetForm()
            this.$emit('created')
            this.busy = false
            this.closeModal()
          }, () => {
            this.busy = false
            this.$notify({ text: 'Link created but image upload failed', type: 'error' })
          })
        } else {
          this.$notify({ text: 'Link created successfully', type: 'success' })
          this.resetForm()
          this.$emit('created')
          this.busy = false
          this.closeModal()
        }
      }, () => {
        this.busy = false
        this.$notify({ text: 'Failed to create link', type: 'error' })
      })
    })
  }

  closeModal () {
    const el = document.getElementById(this.popupId)
    if (el) {
      const closeBtn = el.querySelector('button[data-dismiss="modal"]') as HTMLElement
      if (closeBtn) closeBtn.click()
    }
  }

  resetForm () {
    this.form = {
      link_type: '',
      title: '',
      description: '',
      website_link: '',
      ios_link: '',
      android_link: ''
    }
    this.linkImages = new Array(4)
    this.imageNames = ['', '', '', '']
    this.croppers.forEach((c) => c && c.remove && c.remove())
    this.$nextTick(() => {
      (this as any).errors.clear('create-link-form')
    })
  }
}
